module.exports = __webpack_public_path__ + "static/About Image 3-56df551a88aad2f0213ee997a29fdaf7.jpg";